import { theme } from '@zappyrent/hundop';
import React from 'react';

import { StyledImage, StyledImageWrapper } from './DiscoverZappyrent.styles';

const DiscoverZappyrentImage = (): JSX.Element => {
  return (
    <StyledImageWrapper>
      <StyledImage
        alt="Zappyrent"
        src={`${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-1024.jpg`}
        sizes={`
          (max-width: calc(${theme.breakpoints.l} - 1px)) 100vw,
          50vw
        `}
        srcSet={`
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-512.jpg 512w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-768.jpg 768w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-991.jpg 991w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-1024.jpg 1024w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-1440.jpg 1440w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-1536.jpg 1536w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-1982.jpg 1982w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-2048.jpg 2048w,
          ${process.env.GATSBY_CDN_URL}/who-we-are/most-secure-solution-2880.jpg 2880w,
        `}
      />
    </StyledImageWrapper>
  );
};

export default DiscoverZappyrentImage;
